import { GrowthDashboardTopBarActions, SetupChecklistView } from '@elva/ui';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useSetupChecklist, useSetupChecklistMutations } from '@/features/setup/hooks/useSetupChecklist';

const WEBMASTER_CONTACT_MESSAGE =
  'Please help complete the remaining setup checklist items for our Google Ads & SEO module.';

export function SettingsPage() {
  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } =
    useSetupChecklist();
  const { markDone, contactWebmaster } = useSetupChecklistMutations();

  const loading = isFetching || markDone.isPending || contactWebmaster.isPending;

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
    >
      <SetupChecklistView
        {...viewProps({
          categories: data?.categories,
          isUnseeded: data?.isUnseeded,
          loading,
          onTaskAction: (taskKey: string) => markDone.mutate({ taskKey }),
          onContactWebmaster: () => contactWebmaster.mutate(WEBMASTER_CONTACT_MESSAGE),
        })}
      />
    </AsyncBoundary>
  );
}
